import * as yup from 'yup';
import { TFunction } from 'i18next';
import { LanguageCodes } from '../../../app/data/models/common/localizedLanguage';

export const restaurantValidationSchema = (t: TFunction) =>
  yup.object({
    name: yup
      .string()
      .required(t('validation.restaurant.name.required'))
      .min(2, t('validation.restaurant.name.minLength'))
      .max(150, t('validation.restaurant.name.maxLength')),
    location: yup
      .object({
        latitude: yup.number().optional(),
        longitude: yup.number().optional(),
        address: yup.string().optional(),
        placeId: yup.string().optional(),
      })
      .nullable()
      .test(
        'is-location-valid',
        t('validation.restaurant.location.required'),
        (value) => {
          // If value is null or undefined, it's valid (no location selected)
          if (!value) return true;

          // If location object is present, check if it has an address.
          // If it has an address, then latitude, longitude, and placeId should also be present.
          if (value.address && value.address.trim() !== '') {
            return (
              value.latitude !== undefined &&
              value.longitude !== undefined &&
              value.placeId !== undefined
            );
          }

          // If location object is present but address is empty, it's invalid.
          // This covers cases where a location object exists but is incomplete.
          return false;
        }
      ),
    phoneNumber: yup.string().optional().default(undefined),
    languageCodes: yup
      .array()
      .of(yup.mixed().oneOf(Object.values(LanguageCodes)))
      .transform((value) => value.filter(Boolean))
      .required('Language is required'),
    logo: yup.mixed<File>().optional().default(undefined),
    banner: yup.mixed<File>().optional().default(undefined),
  });
